import { DashboardContent } from './DashboardContent';
import { connect } from 'react-redux';
import { dashboardViewMenuOptionSel } from 'src/store/modules/dashboardview';
import { userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    selected: dashboardViewMenuOptionSel(state),
    userData: userDataSel(state)
  };
};

export const pureComponent = DashboardContent;
export default connect(mapStateToProps, null)(DashboardContent);
